:root{
  --bg:#f7f5f2; --surface:#ffffff; --surface-2:#f4f1ec; --surface-3:#ece7e0;
  --ink:#241f1a; --ink-2:#6f665c; --ink-3:#a89e92;
  --line:#ece7e0; --line-2:#ddd6cc;
  --accent:#c05e35; --accent-press:#a84e2a; --accent-ink:#9e4a28; --accent-wash:#f6e9e1;
  --ok:#5b9a6b; --ok-ink:#467a55; --ok-wash:#e8f1ea;
  --sans:'Public Sans',-apple-system,system-ui,sans-serif;
  --mono:'IBM Plex Mono',ui-monospace,monospace;
  --r:16px; --r-sm:12px; --r-xs:8px;
  --safe-top:env(safe-area-inset-top,0px);
  --safe-bottom:env(safe-area-inset-bottom,0px);
}
*{box-sizing:border-box;-webkit-tap-highlight-color:transparent;}
html,body{margin:0;height:100%;}
body{
  background:var(--bg);
  font-family:var(--sans);
  color:var(--ink);
  -webkit-font-smoothing:antialiased;
  overflow:hidden;
  overscroll-behavior:none;
}
#root{height:100%;}
button{font-family:inherit;cursor:pointer;}
input,textarea{font-family:inherit;}
::-webkit-scrollbar{width:0;height:0;}

/* ── App shell ─────────────────────────────────────── */
.gv-app{height:100%;display:flex;flex-direction:column;background:var(--bg);position:relative;overflow:hidden;}
.gv-scroll{flex:1;overflow-y:auto;overflow-x:hidden;padding:2px 18px 26px;-webkit-overflow-scrolling:touch;}
.gv-scroll.is-flush{padding:0;}
.gv-scroll.has-footer{padding-bottom:18px;}

/* ── Header ────────────────────────────────────────── */
.gv-header{padding:calc(var(--safe-top) + 14px) 18px 10px;background:var(--bg);position:relative;z-index:6;}
.gv-header.is-large{padding-bottom:4px;}
.gv-header-row{display:flex;align-items:center;gap:12px;min-height:40px;}
.gv-header-tt{flex:1;min-width:0;}
.gv-header-sub{font-size:11.5px;color:var(--ink-3);font-family:var(--mono);text-transform:uppercase;letter-spacing:.05em;margin-bottom:2px;}
.gv-header-title{font-size:21px;font-weight:760;letter-spacing:-.02em;color:var(--ink);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.gv-header.is-large .gv-header-title{font-size:29px;letter-spacing:-.03em;}

/* ── Icon button ───────────────────────────────────── */
.gv-iconbtn{width:40px;height:40px;border-radius:11px;border:1px solid var(--line);background:var(--surface);display:flex;align-items:center;justify-content:center;color:var(--ink);flex-shrink:0;}
.gv-iconbtn.is-soft{border:none;background:var(--surface-2);}
.gv-iconbtn:active{background:var(--line);}

/* ── Tab bar + FAB ─────────────────────────────────── */
.gv-tabbar{position:relative;z-index:10;background:rgba(255,255,255,.93);backdrop-filter:blur(14px) saturate(160%);-webkit-backdrop-filter:blur(14px) saturate(160%);border-top:1px solid var(--line);padding-bottom:calc(var(--safe-bottom) + 8px);}
.gv-tabbar-inner{display:flex;align-items:flex-start;justify-content:space-around;height:58px;padding:8px 4px 0;}
.gv-tab{flex:1;display:flex;flex-direction:column;align-items:center;gap:3px;background:none;border:none;color:var(--ink-3);font-size:10px;font-weight:650;letter-spacing:.01em;padding:0;}
.gv-tab.is-active{color:var(--accent-ink);}
.gv-fab{width:52px;height:52px;border-radius:17px;background:var(--accent);color:#fff;display:flex;align-items:center;justify-content:center;border:none;margin:-20px 6px 0;box-shadow:0 6px 16px rgba(192,94,53,.4),0 2px 5px rgba(192,94,53,.3);flex-shrink:0;transition:transform .1s;}
.gv-fab:active{transform:scale(.94);}

/* ── Footer action bar (pushed screens) ───────────── */
.gv-footer{position:relative;z-index:8;background:rgba(255,255,255,.95);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border-top:1px solid var(--line);padding:12px 18px calc(var(--safe-bottom) + 14px);display:flex;gap:10px;align-items:center;}

/* ── Buttons ───────────────────────────────────────── */
.gv-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:50px;padding:0 20px;border-radius:13px;font-size:16px;font-weight:700;border:1px solid transparent;letter-spacing:-.01em;transition:transform .08s,background .15s;}
.gv-btn:active{transform:scale(.985);}
.gv-btn.is-primary{background:var(--accent);color:#fff;}
.gv-btn.is-primary:active{background:var(--accent-press);}
.gv-btn.is-secondary{background:var(--surface);color:var(--ink);border-color:var(--line-2);}
.gv-btn.is-ghost{background:transparent;color:var(--accent-ink);}
.gv-btn.is-danger{background:#fff;color:#bf332c;border-color:#eec6c3;}
.gv-btn.is-dark{background:var(--ink);color:#fff;}
.gv-btn.is-sm{height:38px;font-size:14px;border-radius:10px;padding:0 14px;gap:6px;}
.gv-btn.is-full{width:100%;}
.gv-btn:disabled{opacity:.42;}

/* ── Badge ─────────────────────────────────────────── */
.gv-badge{display:inline-flex;align-items:center;gap:6px;height:24px;padding:0 10px;border-radius:999px;font-size:12px;font-weight:700;letter-spacing:.005em;white-space:nowrap;}
.gv-badge.is-sm{height:20px;font-size:10.5px;padding:0 8px;gap:5px;border-radius:999px;}
.gv-badge-dot{width:6px;height:6px;border-radius:50%;flex-shrink:0;}

/* ── Card ──────────────────────────────────────────── */
.gv-card{background:var(--surface);border:1px solid var(--line);border-radius:var(--r);padding:16px;}
.gv-card.is-tap{transition:transform .08s,border-color .15s;}
.gv-card.is-tap:active{transform:scale(.992);border-color:var(--line-2);}

/* ── Section label ─────────────────────────────────── */
.gv-seclabel{display:flex;align-items:center;justify-content:space-between;margin:22px 2px 9px;}
.gv-seclabel>span{font-family:var(--mono);font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;color:var(--ink-3);}
.gv-seclabel-act{background:none;border:none;color:var(--accent-ink);font-weight:700;font-size:13px;}

/* ── Avatar ────────────────────────────────────────── */
.gv-avatar{border-radius:50%;background:var(--accent-wash);color:var(--accent-ink);display:flex;align-items:center;justify-content:center;font-weight:760;flex-shrink:0;}

/* ── Fields ────────────────────────────────────────── */
.gv-field{display:flex;flex-direction:column;gap:7px;}
.gv-label{font-size:13px;font-weight:650;color:var(--ink-2);}
.gv-input-wrap{display:flex;align-items:center;gap:8px;background:var(--surface);border:1px solid var(--line-2);border-radius:12px;padding:0 14px;min-height:48px;transition:border-color .15s,box-shadow .15s;}
.gv-input-wrap:focus-within{border-color:var(--accent);box-shadow:0 0 0 3px var(--accent-wash);}
.gv-input-wrap.is-read{background:var(--surface-2);}
.gv-input{flex:1;border:none;background:none;outline:none;font-size:16px;color:var(--ink);min-width:0;padding:13px 0;}
.gv-input.is-mono{font-family:var(--mono);}
textarea.gv-input{resize:none;line-height:1.45;}
.gv-affix{font-size:13.5px;color:var(--ink-3);font-family:var(--mono);white-space:nowrap;}
.gv-input::placeholder,textarea.gv-input::placeholder{color:var(--ink-3);}

/* ── Stepper ───────────────────────────────────────── */
.gv-step{display:inline-flex;align-items:center;background:var(--surface);border:1px solid var(--line-2);border-radius:11px;height:40px;overflow:hidden;}
.gv-step-btn{width:38px;height:38px;display:flex;align-items:center;justify-content:center;background:none;border:none;color:var(--ink);}
.gv-step-btn:active{background:var(--surface-3);}
.gv-step-val{width:50px;text-align:center;border:none;background:none;outline:none;font-family:var(--mono);font-size:15px;font-weight:600;color:var(--ink);border-left:1px solid var(--line);border-right:1px solid var(--line);height:38px;}
.gv-step.is-sm{height:34px;}
.gv-step.is-sm .gv-step-btn{width:30px;height:32px;}
.gv-step.is-sm .gv-step-val{width:36px;height:32px;font-size:13.5px;}

/* ── Bottom sheet ──────────────────────────────────── */
.gv-sheet-backdrop{position:absolute;inset:0;z-index:100;background:rgba(13,16,18,0);display:flex;align-items:flex-end;transition:background .28s;}
.gv-sheet-backdrop.is-open{background:rgba(13,16,18,.42);}
.gv-sheet{width:100%;background:var(--surface);border-radius:24px 24px 0 0;transform:translateY(100%);transition:transform .3s cubic-bezier(.32,.72,0,1);display:flex;flex-direction:column;padding-bottom:calc(var(--safe-bottom) + 24px);box-shadow:0 -10px 44px rgba(0,0,0,.16);}
.gv-sheet.is-open{transform:translateY(0);}
.gv-sheet-grab{width:38px;height:4.5px;border-radius:3px;background:var(--line-2);margin:10px auto 2px;}
.gv-sheet-head{display:flex;align-items:center;justify-content:space-between;padding:8px 18px 12px;font-size:18px;font-weight:740;}
.gv-sheet-body{overflow-y:auto;padding:6px 18px 4px;}

/* ── Map ───────────────────────────────────────────── */
.gv-map{position:relative;border-radius:14px;overflow:hidden;background:#e9ede9;border:1px solid var(--line);}
.gv-map-pin{position:absolute;transform:translate(-50%,-100%);z-index:3;display:flex;flex-direction:column;align-items:center;}
.gv-map-pin-dot{width:17px;height:17px;border-radius:50%;background:var(--accent);border:3.5px solid #fff;box-shadow:0 1px 5px rgba(0,0,0,.4);}
.gv-map-pin-stem{width:3px;height:8px;background:var(--accent);margin-top:-1px;border-radius:0 0 2px 2px;}
.gv-map-label{position:absolute;left:10px;bottom:10px;background:rgba(255,255,255,.95);border-radius:8px;padding:5px 9px;font-size:11px;font-weight:600;font-family:var(--mono);box-shadow:0 1px 4px rgba(0,0,0,.14);max-width:75%;}
.gv-map-grain{position:absolute;inset:0;pointer-events:none;box-shadow:inset 0 0 0 1px rgba(0,0,0,.03);}

/* ── Generic list rows (inside a card) ─────────────── */
.gv-list{background:var(--surface);border:1px solid var(--line);border-radius:var(--r);overflow:hidden;}
.gv-lrow{display:flex;align-items:center;gap:13px;padding:14px 16px;border-bottom:1px solid var(--line);}
.gv-lrow:last-child{border-bottom:none;}
.gv-lrow.is-tap:active{background:var(--surface-2);}
.gv-lrow-ic{width:36px;height:36px;border-radius:10px;background:var(--surface-2);display:flex;align-items:center;justify-content:center;color:var(--ink-2);flex-shrink:0;}
.gv-lrow-tt{flex:1;min-width:0;}
.gv-lrow-tt b{font-size:15.5px;font-weight:650;display:block;}
.gv-lrow-tt span{font-size:13px;color:var(--ink-3);}

/* ── meta line (icon + text) ───────────────────────── */
.gv-meta{display:flex;align-items:center;gap:7px;color:var(--ink-2);font-size:14px;}
.gv-mono{font-family:var(--mono);}
.gv-tnum{font-family:var(--mono);font-variant-numeric:tabular-nums;}

/* ── tiny pill / chip ──────────────────────────────── */
.gv-chip{display:inline-flex;align-items:center;gap:6px;height:30px;padding:0 12px;border-radius:9px;font-size:13px;font-weight:600;background:var(--surface);border:1px solid var(--line-2);color:var(--ink-2);}
.gv-chip.is-on{background:var(--ink);color:#fff;border-color:var(--ink);}

@media (prefers-reduced-motion: no-preference){
  .gv-fade{animation:gvfade .3s ease;}
}
@keyframes gvfade{from{transform:translateY(7px);}to{transform:none;}}
@keyframes gvspin{to{transform:rotate(360deg);}}
.gv-spin{animation:gvspin .9s linear infinite;}
@keyframes gvpulse{0%,100%{opacity:1;}50%{opacity:.45;}}

/* ── Calendar ──────────────────────────────────────── */
.gv-cal-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:2px;}
.gv-cal-wd{text-align:center;font-family:var(--mono);font-size:10.5px;font-weight:600;color:var(--ink-3);text-transform:uppercase;padding:4px 0 6px;}
.gv-cal-day{aspect-ratio:1;border:none;background:none;border-radius:11px;font-size:15px;font-weight:600;color:var(--ink);display:flex;align-items:center;justify-content:center;font-variant-numeric:tabular-nums;}
.gv-cal-day:active{background:var(--surface-2);}
.gv-cal-day.is-muted{color:var(--ink-3);opacity:.4;}
.gv-cal-day.is-today{box-shadow:inset 0 0 0 1.5px var(--line-2);}
.gv-cal-day.is-sel{background:var(--accent);color:#fff;}
.gv-cal-day.is-disabled{color:var(--ink-3);opacity:.28;pointer-events:none;}

/* ── Month calendar (Kalender tab) ─────────────────── */
.gv-mcal{display:grid;grid-template-columns:repeat(7,1fr);gap:4px;}
.gv-mcal-wd{text-align:center;font-family:var(--mono);font-size:9.5px;font-weight:600;color:var(--ink-3);text-transform:uppercase;padding:2px 0 5px;}
.gv-mcell{position:relative;aspect-ratio:.84;border:1px solid var(--line);background:var(--surface);border-radius:10px;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;padding:5px 2px 3px;gap:3px;overflow:hidden;}
.gv-mcell .num{font-size:13px;font-weight:650;color:var(--ink);font-variant-numeric:tabular-nums;line-height:1;}
.gv-mcell.is-weekend{background:var(--surface-2);}
.gv-mcell.is-today .num{color:#fff;background:var(--accent);width:21px;height:21px;border-radius:50%;display:flex;align-items:center;justify-content:center;}
.gv-mcell.is-sel{border-color:var(--accent);box-shadow:0 0 0 2px var(--accent-wash);}
.gv-mcell .load{font-family:var(--mono);font-size:8.5px;font-weight:700;line-height:1;color:var(--accent-ink);white-space:nowrap;}
.gv-mcell .bars{display:flex;gap:1.5px;}
.gv-mcell .bars i{width:4px;height:4px;border-radius:50%;background:var(--accent);display:block;}

/* ── Receipt scan ──────────────────────────────────── */
.gv-drop{border:1.5px dashed var(--line-2);border-radius:16px;background:var(--surface);padding:30px 20px;display:flex;flex-direction:column;align-items:center;text-align:center;gap:4px;}
.gv-rcpt-thumb{width:100%;height:130px;border-radius:13px;overflow:hidden;background:var(--surface-2);border:1px solid var(--line);object-fit:cover;display:block;}

/* ── Auth screen ───────────────────────────────────── */
.gv-auth{height:100%;display:flex;flex-direction:column;justify-content:center;padding:calc(var(--safe-top) + 24px) 24px calc(var(--safe-bottom) + 24px);background:var(--bg);overflow-y:auto;}
.gv-auth-brand{text-align:center;margin-bottom:28px;}
.gv-auth-logo{max-width:280px;border-radius:18px;background:#fff;border:1px solid var(--line);display:flex;align-items:center;justify-content:center;margin:0 auto 16px;padding:16px 22px;box-shadow:0 10px 26px rgba(0,0,0,.09);}
.gv-auth-logo img{width:100%;height:auto;object-fit:contain;display:block;}
.gv-auth-title{font-size:26px;font-weight:780;letter-spacing:-.03em;}
.gv-auth-sub{font-size:14px;color:var(--ink-3);font-family:var(--mono);text-transform:uppercase;letter-spacing:.05em;margin-top:4px;}
.gv-auth-card{background:var(--surface);border:1px solid var(--line);border-radius:var(--r);padding:20px;display:flex;flex-direction:column;gap:14px;}
.gv-auth-err{background:#fdecea;color:#bf332c;border:1px solid #eec6c3;border-radius:10px;padding:10px 12px;font-size:13.5px;font-weight:600;}
.gv-auth-divider{display:flex;align-items:center;gap:12px;color:var(--ink-3);font-size:12px;font-family:var(--mono);text-transform:uppercase;letter-spacing:.06em;}
.gv-auth-divider::before,.gv-auth-divider::after{content:'';flex:1;height:1px;background:var(--line-2);}
.gv-google-btn{display:flex;align-items:center;justify-content:center;gap:10px;height:50px;border-radius:13px;border:1px solid var(--line-2);background:var(--surface);font-size:15.5px;font-weight:700;color:var(--ink);width:100%;}
.gv-google-btn:active{background:var(--surface-2);}
.gv-auth-toggle{text-align:center;font-size:14px;color:var(--ink-2);}
.gv-auth-toggle button{background:none;border:none;color:var(--accent-ink);font-weight:700;font-size:14px;}

/* ── Full-screen loader ────────────────────────────── */
.gv-loading{height:100%;display:flex;align-items:center;justify-content:center;background:var(--bg);color:var(--ink-3);}
